import type { TemplateOnlyComponent } from '@ember/component/template-only';
import pageTitle from 'ember-page-title/helpers/page-title';
import NavBar from 'bcl/components/nav-bar';
import NotificationArea from 'bcl/components/notification-area';
export default <template>
  {{pageTitle "Barvera"}}

  <div class="min-h-full">
    <NavBar />
    {{outlet}}
  </div>
  <NotificationArea />
</template> satisfies TemplateOnlyComponent<{
  Args: { model: unknown; controller: unknown };
}>;
